import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname, hash } = useLocation();
  const isFirstRender = useRef(true);

  useEffect(() => {
    document.documentElement.style.setProperty("scroll-behavior", "smooth", "important");
    document.body.style.setProperty("scroll-behavior", "smooth", "important");
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }

    const isInitialLoad = isFirstRender.current;
    isFirstRender.current = false;

    const navEntry = performance.getEntriesByType("navigation")[0];
    const isReloadNavigation =
      isInitialLoad &&
      (navEntry?.type === "reload" ||
        (window.performance.navigation && window.performance.navigation.type === 1));

    const scrollToHash = (hashValue, attempt = 0) => {
      if (!hashValue) return;

      const id = decodeURIComponent(hashValue.replace("#", ""));
      const element = document.getElementById(id);

      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "start" });
        return;
      }

      if (attempt < 12) {
        window.setTimeout(() => scrollToHash(hashValue, attempt + 1), 70);
      }
    };

    if (isReloadNavigation) {
      if (window.location.hash) {
        const cleanUrl = `${window.location.pathname}${window.location.search}`;
        window.history.replaceState(null, "", cleanUrl);
      }
      window.scrollTo({ top: 0, left: 0, behavior: "auto" });
      return;
    }

    if (hash) {
      scrollToHash(hash);
      return;
    }

    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, [pathname, hash]);

  return null;
}
